var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eye-show"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.865 6.954c-.313.636-1.318 2.002-2.504 3.108C14.395 11.897 12.094 13 9.488 13c-2.604 0-4.904-1.107-6.872-2.95A14.717 14.717 0 01.8 7.999c-.33-.45-.598-.874-.696-1.062a.946.946 0 01-.013-.848c.288-.615 1.312-2.019 2.524-3.15C4.582 1.103 6.883 0 9.488 0c2.605 0 4.905 1.107 6.874 2.949.693.648 1.3 1.348 1.815 2.053.312.426.568.827.68 1.032.188.274.19.643.008.92zM15.679 3.68C13.88 1.997 11.809 1 9.489 1c-2.323 0-4.395.994-6.19 2.67C2.192 4.701 1.253 5.982.995 6.517 1.002 6.498 1 6.49.99 6.471c.325.618 1.196 1.809 2.309 2.85C5.097 11.003 7.168 12 9.489 12c2.322 0 4.395-.994 6.19-2.67 1.11-1.035 2.051-2.32 2.294-2.829-.335-.625-1.198-1.796-2.294-2.822zM.995 6.517a1.731 1.731 0 00.003-.005l-.003.005zm17.045.093l-.02-.032c.005.01.012.021.02.032z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.472 6.5a3 3 0 10-6 0 3 3 0 006 0zm1 0a4 4 0 11-8 0 4 4 0 018 0z",
    id: "Stroke-3"
  }))))));
}
SvgEyeShow.displayName = 'EyeShow';
export default SvgEyeShow;